import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { ReferenceRateValue } from 'src/features/referenceRateValues/utils/types';
import { PatchReferenceRateValueFormSchemaValues } from 'src/features/referenceRateValues/utils/formSchema';

const RESOURCE = '/subscriptions/reference-rate/:referenceRateId/reference-rate-value/:valueId/';

type MutationFnType = typeof mutationFn;

interface DTO extends PatchReferenceRateValueFormSchemaValues {
    referenceRateId: string;
    valueId: string;
}

const mutationFn = ({ referenceRateId, valueId, ...data }: DTO): Promise<ReferenceRateValue> => {
    return axios.patch(formatResourcePath(RESOURCE, { referenceRateId, valueId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as usePatchReferenceRateValue };
